import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

/**
 * Creates a Stripe Connect account for the club and returns
 * the onboarding URL. The admin is redirected to Stripe to
 * enter bank details.
 */
export async function startConnectOnboarding(
  clubId: string,
  returnUrl: string,
  forceNew = false
) {
  const fn = httpsCallable<
    { clubId: string; returnUrl: string; refreshUrl: string; forceNew?: boolean },
    { url: string; accountId: string }
  >(functions, "createConnectAccount");

  const result = await fn({
    clubId,
    returnUrl,
    refreshUrl: returnUrl,
    forceNew,
  });

  return result.data;
}

/**
 * Checks whether the club's Stripe Connect onboarding is complete.
 */
export async function checkConnectStatus(clubId: string) {
  const fn = httpsCallable<
    { clubId: string },
    {
      connected: boolean;
      payoutsEnabled: boolean;
      detailsSubmitted: boolean;
      chargesEnabled?: boolean;
    }
  >(functions, "checkConnectStatus");

  const result = await fn({ clubId });
  return result.data;
}

/**
 * Gets a login link to the club's Stripe dashboard.
 */
export async function getStripeDashboardLink(clubId: string) {
  const fn = httpsCallable<{ clubId: string }, { url: string }>(
    functions,
    "createConnectLoginLink"
  );

  const result = await fn({ clubId });
  return result.data;
}
